import { type Registry as Services, service } from '@ember/service';
import BaseStorageService from 'lumen/services/base/storage';

export const LOCAL_STORAGE_KEYS = {
  RATE_TABLE_COLUMNS: 'rate-table-columns',
  BUDGET_FORECAST_DISTRIBUTION_METHOD: 'budget-forecast-distribution-method',
  RATE_TABLE_COMPARISON_LAYOUT: 'rate-table-comparison-layout',
  IS_PRIMA_TABLE_BASE_ROOM_ROW_COLLAPSED:
    'is-prima-table-base-room-row-collapsed',
  MARKET_SNAPSHOTS_DATA_PREFERENCES: 'market-snapshots-data-preferences',
  MARKET_SNAPSHOTS_TABLE_LAYOUT: 'market-snapshots-table-layout',
};

export default class LocalStorageService extends BaseStorageService {
  @service declare errorTracking: Services['error-tracking'];

  constructor() {
    // eslint-disable-next-line prefer-rest-params
    super(...arguments);
    try {
      this.intendedStorage = window.localStorage;
    } catch {
      this.intendedStorage = {};
      this.errorTracking.addBreadcrumb({
        message: 'Could not access localStorage',
      });
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    'local-storage': LocalStorageService;
  }
}
